
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <rect x="5.5" y="16.9" width="13" height="2.2"></rect><line x1="5" y1="21.5" x2="19" y2="21.5"></line><path d="M16 6.4C16 7.07591 15.5705 7.8241 14.9896 8.64835C14.8874 8.79336 14.7783 8.94392 14.6687 9.09516C14.4894 9.34272 14.3087 9.59209 14.1548 9.82188C13.9048 10.1952 13.6692 10.5957 13.5628 10.9899C13.281 12.033 13.2913 13.2589 13.8621 14.3H10.1651C10.3902 13.9301 10.5615 13.5285 10.6636 13.1199C10.852 12.3661 10.8147 11.5394 10.3762 10.8515C10.2146 10.598 9.99894 10.303 9.77394 9.99525C9.74423 9.95462 9.71436 9.91376 9.68443 9.87274C9.42246 9.51375 9.14556 9.12914 8.89122 8.72836C8.3711 7.90877 8 7.10281 8 6.4C8 4.25662 9.78021 2.5 12 2.5C14.2198 2.5 16 4.25662 16 6.4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiApprovalComponent",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
